import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { exchangeSession, getSessionId } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setAuthUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Get session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id in URL');
          navigate('/');
          return;
        }

        const sessionId = sessionIdMatch[1];
        
        // Get the anonymous session ID to attach profile
        const anonymousSessionId = getSessionId();

        // Exchange session with backend
        const result = await exchangeSession(sessionId, anonymousSessionId);

        if (result.user && result.session_token) {
          // Set auth state
          setAuthUser(result.user, result.session_token);
          
          // Clear URL fragment and redirect to dashboard
          window.history.replaceState(null, '', window.location.pathname);
          navigate('/dashboard', { replace: true, state: { user: result.user } });
        } else {
          throw new Error('Invalid response from server');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/', { replace: true });
      }
    };

    processAuth();
  }, [navigate, setAuthUser]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-mist via-mist-light to-fern flex items-center justify-center">
      <div className="text-center space-y-4">
        <Loader2 className="h-12 w-12 animate-spin text-forest mx-auto" />
        <p className="text-calm-text-secondary">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
